import { IFinancialStatementInterpretation } from '@modeso/types__aumico-lib-annualreport-be';
import { TaxonomyDefinitions } from '../../../../aumico-lib-annualreport-fe/src/lib/helpers/datev.excel.helper';
import { AccountMappingData } from '../types/AccountMappingData.type';

export interface IAccountMappingFormInput {
    income: AccountMappingData;
    balance: AccountMappingData;
    sheetSystem: IFinancialStatementInterpretation;
    dates: {
        balanceStartDate: string;
        balanceEndDate: string;
        incomeStartDate: string;
        incomeEndDate: string;
    };
    previousYearBalanceDuplicateAccountNumber?: Set<string> | undefined;
    previousYearIncomeDuplicateAccountNumber?: Set<string> | undefined;
    applyUncoveredShortfall?: boolean;
    uncoveredShortfallAssetsFli?: string;
    uncoveredShortfallLiabilitiesFli?: string;
    //This property shall overwrite what is selected in income and balance properties
    importedTaxonomyDefinitions?: TaxonomyDefinitions;
}
